export default __webpack_public_path__ + "static/media/img-1.66329a13.png";